import { SoftwareReleaseService } from "@app/software-releases";
import { FC, JSX, useContext, useEffect, useRef, useState } from "react";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface CreateSoftwareReleasePanelProps {
  handleConfirm: (result: string) => void,
}


const CreateSoftwareReleasePanelContent: FC<CreateSoftwareReleasePanelProps> = (props: CreateSoftwareReleasePanelProps) => {
  const flyoutContext = useContext(FlyoutContext);
  const softwareReleaseService = useRef(new SoftwareReleaseService()).current;

  const [formIsValid, setFormIsValid] = useState(false);
  const [releaseVersionOptions, setReleaseVersionOptions] = useState<JSX.Element[]>([]);
  const [selectedReleaseVersion, setSelectedReleaseVersion] = useState<string>(null);

  useEffect(() => {
    softwareReleaseService.getUnallocatedReleases().then((unallocatedReleases) => {
      setReleaseVersionOptions([<option value="-1" key="-1">Select a Release Version</option>, ...unallocatedReleases.map(r => <option value={r} key={r}>{r}</option>)]);
    });
  }, []);

  const handleReleaseVersionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSelectedReleaseVersion = e.target.value;
    const newFormIsValid = !!newSelectedReleaseVersion && newSelectedReleaseVersion != "-1";

    setFormIsValid(newFormIsValid);
    setSelectedReleaseVersion(newSelectedReleaseVersion);
  }

  return (
    <>
      <div className="row mt-3">
        <div className="col-12">
          <QESSelect
            containerClassName="col-10 mb-3 px-2"
            label="Release Version"
            testId="new-release_release-version"
            onChange={handleReleaseVersionChange}
          >
            {releaseVersionOptions}
          </QESSelect>
        </div>
      </div>
      <FlyoutFooter
        submitButton={
          <QESButton
            qesTestId="create-software-release-panel-content_confirm"
            disabled={!formIsValid}
            onClick={() => { props.handleConfirm(selectedReleaseVersion); flyoutContext.handleCloseFlyout(); }}
          >
            Create
          </QESButton>}
      />
    </>
  );
}

export default CreateSoftwareReleasePanelContent;
